export const getUserName = (user) => {
    const fullName = `${user.firstname} ${user.lastname}`.trim();

    return fullName || user.primaryEmailAddress;
};

